// Converts Speicher's plain-text section body into safe HTML.
// Blank line = new paragraph, lines starting with "-", "*" or "•" = bullets,
// **bold** and [link text](/path or https://url) are supported inline.

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const BULLET_RE = /^\s*[-*\u2022]\s+/;

function inline(text, linkClass) {
  return escapeHtml(text)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\[([^\]]+)\]\(((?:\/|https?:\/\/)[^\s)]*)\)/g, (_m, label, href) => {
      const external = href.startsWith("http") && !href.includes("ezeefitofficesystems.in");
      const rel = external ? ' target="_blank" rel="noopener noreferrer"' : "";
      return `<a href="${href}" class="${linkClass}"${rel}>${label}</a>`;
    });
}

export function sectionBodyToHtml(body, classes) {
  const out = [];
  const blocks = String(body || "").replace(/\r/g, "").split(/\n\s*\n/);
  blocks.forEach((block) => {
    let para = [];
    let bullets = [];
    const flushPara = () => {
      if (para.length) out.push(`<p class="${classes.p}">${para.map((l) => inline(l, classes.a)).join("<br>")}</p>`);
      para = [];
    };
    const flushBullets = () => {
      if (bullets.length) out.push(`<ul class="${classes.ul}">${bullets.map((l) => `<li>${inline(l, classes.a)}</li>`).join("")}</ul>`);
      bullets = [];
    };
    block.split("\n").forEach((line) => {
      if (!line.trim()) return;
      if (BULLET_RE.test(line)) {
        flushPara();
        bullets.push(line.replace(BULLET_RE, ""));
      } else {
        flushBullets();
        para.push(line.trim());
      }
    });
    flushPara();
    flushBullets();
  });
  return out.join("");
}

export const INLINE_CLASSES = {
  h2: "text-2xl md:text-3xl font-bold leading-tight mb-4",
  h3: "text-xl md:text-2xl font-semibold leading-snug mb-3",
  p: "text-base leading-relaxed mb-4 opacity-90",
  ul: "list-disc pl-6 space-y-2 mb-4 opacity-90",
  a: "text-[#F97316] underline underline-offset-2 hover:text-[#EA580C]",
};

export const END_CLASSES = {
  h2: "text-2xl md:text-3xl font-bold leading-tight mb-4 text-[#0F172A]",
  h3: "text-xl md:text-2xl font-semibold leading-snug mb-3 text-[#0F172A]",
  p: "text-base leading-relaxed mb-4 text-[#475569]",
  ul: "list-disc pl-6 space-y-2 mb-4 text-[#475569]",
  a: "text-[#F97316] underline underline-offset-2 hover:text-[#EA580C]",
};

export function sectionToHtml(section, classes) {
  const tag = section.heading_level === "h3" ? "h3" : "h2";
  return `<${tag} class="${classes[tag]}">${escapeHtml(section.heading)}</${tag}>${sectionBodyToHtml(section.body, classes)}`;
}
